// Sessão de enrollment expirada: os endpoints de enrollment do BE respondem
// 410 Gone nesse caso (400 é código TOTP inválido), e o formatError do BFF
// propaga o status HTTP em `extensions.code`.
export const isMfaEnrollmentSessionExpired = error =>
  !!error?.graphQLErrors?.some(
    graphQLError => graphQLError?.extensions?.code === 410,
  );
